const MessageDB = {
    networkError: `Looks like something is wrong with your network. Please try later.`,
    genericError: `Looks like something is wrong. Please try later.`,
    forbiddenError: `Please do not try to play with us.`,
};

export default MessageDB;
